/// <reference path="../node_modules/phaser/typescript/phaser.d.ts"/>
/// <reference path="../node_modules/phaser/typescript/pixi.d.ts"/>

import 'pixi';
import 'p2';
import * as Phaser from 'phaser';
import {PlayState} from "./playstate";
import {MenuState} from "./menustate";
import {LevelCompleteState} from "./levelcompletestate";

import State = Phaser.State;

class SimpleGame extends Phaser.Game{

  constructor() {
    let width = document.documentElement.clientWidth > 400 ? 400 : document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight > 600 ? 600 : document.documentElement.clientHeight;

     // let width = (window.innerWidth) > 400 ? 400 : (window.innerWidth);
      //let height = (window.innerHeight) > 600 ? 600 : (window.innerHeight);
    //let width = 400;
    //let height = 600;


    super(width, height, Phaser.AUTO, 'content', null);

    this.state.add('PlayState', PlayState, false);
    this.state.add('MenuState', MenuState, false);
    this.state.add('LevelCompleteState', LevelCompleteState, false);
    this.state.start('MenuState');
  }
}

window.onload = () => {
  const game = new SimpleGame();
};



// WEBPACK FOOTER //
// ./src/index.ts